/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Session')
    .factory('AccountInterceptor', [
        function () {
            return {
                response: (response) => {
                    const account = response.resource;

                    account.isAdmin = () => account.is_admin;

                    account.getQuotaPercentage = () => account.sync_and_share_content ?
                        account.sync_and_share_content.used_space / account.quota * 100 :
                        0;

                    account.isQuotaAlmostFull = account.getQuotaPercentage() > 90;

                    account.quotaStyle = () => ({
                        width: account.getQuotaPercentage() + '%'
                    });

                    account.hasSyncAndShareAccess = () => account.allow_sync_and_share;

                    account.canManageQuota = () => account.quota && account.licensed && account.allow_sync_and_share;

                    account.canPurgeContent = () => account.licensed && !account.quota && !!account.global_quota;

                    account.canSync = () => account.licensed;

                    account.hasDesktopClient = () => account.has_desktop_client;

                    account.lastSyncWithDesktop = () => account.last_desktop_client_contact;

                    account.hasAdminAccess = () => account.isAdmin();

                    account.canManageNotifications = () => account.hasSyncAndShareAccess();

                    return account;
                }
            };
        }
    ]);
